

export interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  content?: string;
  image_url?: string;
  created_at: string;
  category?: string;
}

const FALLBACK_POSTS: BlogPost[] = [
  {
    id: 101,
    title: 'Guia do Metagame de One Piece TCG',
    excerpt: 'Confira as principais estratégias, decks dominantes e análises das cartas mais populares no meta atual de One Piece.',
    created_at: new Date().toISOString(),
    image_url: 'https://images.unsplash.com/photo-1614850523296-d8c1af93d400?auto=format&fit=crop&q=80&w=800',
    category: 'Estratégia'
  },
  {
    id: 102,
    title: 'Dicas para Montagem de Decks Competitivos',
    excerpt: 'Aprenda a otimizar a curva de custo, sinergia entre cartas e consistência para alavancar suas vitórias nos torneios.',
    created_at: new Date().toISOString(),
    image_url: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&q=80&w=800',
    category: 'Deck Building'
  },
  {
    id: 103,
    title: 'Próximos Torneios e Eventos Comunitários',
    excerpt: 'Fique por dentro das datas, premiações e regulamentos oficiais para os próximos campeonatos da comunidade Cardumy.',
    created_at: new Date().toISOString(),
    image_url: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&q=80&w=800',
    category: 'Comunidade'
  }
];

export const fetchLatestPosts = async (perPage: number = 3): Promise<BlogPost[]> => {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3500);

    const response = await fetch(`https://cardumy.blog/wp-json/wp/v2/posts?_embed&per_page=${perPage}`, {
      signal: controller.signal
    });
    clearTimeout(timeoutId);
    
    if (!response.ok) {
      return FALLBACK_POSTS.slice(0, perPage);
    }

    const data = await response.json();
    if (!Array.isArray(data) || data.length === 0) {
      return FALLBACK_POSTS.slice(0, perPage);
    }

    return data.map((post: any) => ({
      id: post.id,
      title: post.title?.rendered || 'Post do Blog',
      excerpt: (post.excerpt?.rendered || '').replace(/<[^>]*>?/gm, '').substring(0, 120).trim() + '...',
      content: post.content?.rendered || '',
      created_at: post.date || new Date().toISOString(),
      image_url: post._embedded?.['wp:featuredmedia']?.[0]?.source_url || FALLBACK_POSTS[0].image_url,
      category: post._embedded?.['wp:term']?.[0]?.[0]?.name || 'Blog'
    }));
  } catch (error) {
    return FALLBACK_POSTS.slice(0, perPage);
  }
};
